import { Contain } from '../Grid';

const Annex = () => (
  <>
    <Contain className="text-center">
      <h2>Annex A</h2>
      <h2>
        <u>LINK Data Protection Reporting Processes</u>
      </h2>
    </Contain>
    <p>
      The Contractor will notify LINK both orally and in writing, as promptly as possible under the
      circumstances and without unreasonable delay, of any Security Breach involving any Personal
      Data no later than 24 hours upon discovery. As used herein, &ldquo;Security Breach&rdquo; is
      defined as any event involving a known, actual, or suspected compromise of the security,
      confidentiality or integrity of the customer Personal Data of LINK, including but not limited
      to any loss or unauthorized access except where such Security Breach is due to the sole fault
      of a customer.
    </p>
    <p>
      The Contractor will use commercially reasonable efforts to contain such a breach and provide
      the LINK with a detailed timeline and description of the Security Breach, the type of data
      that was the subject of the Security Breach and the corrective action taken to respond to the
      breach and, upon two (2) Business Days prior written request, will provide access to LINK to
      investigate such breach, if required.
    </p>
    <p>
      The Contractor agrees to take action immediately, at its own expense, to investigate the
      Security Breach, to take all commercially reasonable actions to identify, prevent, and
      mitigate the effects of any such Security Breach, and to carry out any recovery or other
      action (e.g., providing credit monitoring services) necessary to remedy the Security Breach
      and prevent any further incidents .
    </p>
    <p>
      The Contractor undergoing the Security Breach shall make commercially reasonable efforts to
      give LINK a reasonable opportunity to consult in advance on any filings, communications,
      notices, press releases or reports related to any Security Breach, but the final decision on
      their contents shall belong to LINK.
    </p>
    <p>
      The Contractor will reimburse LINK on demand for all reasonable Notification Related Costs
      incurred by LINK arising out of or in connection with any such Security Breach resulting in a
      requirement for legally required notifications. &ldquo;Notification Related Costs&rdquo; shall
      include LINK internal and external costs associated with addressing and responding to the
      Security Breach, including but not limited to: (a) preparation and mailing or other
      transmission of legally required notifications; (b) preparation and mailing or other
      transmission of such other communications to customers, agents or others as LINK deems
      reasonably appropriate; (c) establishment of a call centre or other communications procedures
      in response to such Security Breach (e.g., customer service FAQs, talking points and
      training); (d) legal and accounting fees and expenses associated with LINK investigation of
      Security Breach.
    </p>
  </>
);

export default Annex;
